// Angular
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

// Local
import { IdentityClaimsService } from '@app/services/identity-claims/identity-claims.service';
import { ROUTES } from '@routes';

/**
 * Blocks Form 50 Agent and SRI users from Organization Settings pages that do not apply to their
 * single-account org (Manage User, User Permissions, Add User). A Form 50 Agent or SRI user who deep-links to
 * one of these routes is redirected to the Organization Settings landing rather than shown a page that
 * has no meaning for them. Emulation-aware via {@link IdentityClaimsService} so it honors an admin
 * emulating a Form 50 Agent.
 */
export const blockSRIForm50AgentGuard: CanActivateFn = () => {
  const router = inject(Router);
  const identityClaimsService = inject(IdentityClaimsService);

  return identityClaimsService.isAccountSettingsUser()
    ? router.parseUrl(`/${ROUTES.PREFERENCES}`)
    : true;
};
